import { API_APP_SETTING, API_LOGS } from '../configs/api'
import networkAdapter from '../utilities/networkAdapter'

export const getAppSetting = (params: { app_id: string }) => {
  return networkAdapter.get(API_APP_SETTING, params)
}

interface logType {
  digital_id:number,
  login_time: string
  device_name: string
  os_version: string
  browser: string
}

export const apiLogDevice = async (data: logType) => {
  const postLog = await networkAdapter.post(API_LOGS, data)
  return postLog
}
